import { analyticsState, fetchAnalytics } from '@/stores/analytics';
import { GlobalFilterState } from '@/global_filter';
import { useAsyncEffect } from '@/utils';
import { MetricSection } from './metric-section';
import { createMetricSections } from './metric-definitions';

interface AnalyticsDashboardProps {
  className?: string;
}

export function AnalyticsDashboard({ className }: AnalyticsDashboardProps) {
  const { data, isLoading, error } = analyticsState.use();
  const { startDate, endDate, distributor } = GlobalFilterState.use(gf => gf!);

  useAsyncEffect(async () => {
    await fetchAnalytics(startDate || undefined, endDate || undefined, distributor || undefined);
  }, [startDate, endDate, distributor]);

  if (error) {
    return (
      <div class={`p-6 text-destructive ${className || ''}`}>
        Error loading analytics: {error}
      </div>
    );
  }

  if (isLoading && !data) {
    return (
      <div class={`p-6 ${className || ''}`}>
        <div class="animate-pulse">
          <div class="h-8 bg-gray-200 rounded mb-4"></div>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} class="h-24 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div class={`p-6 text-muted-foreground ${className || ''}`}>
        No analytics data available
      </div>
    );
  }

  return (
    <div class={className}>
      <div class="p-6 pt-0 border-b">
        <div>
          <h1 class="text-2xl font-semibold">Operational Metrics</h1>
        </div>
      </div>
      
      <div class="p-6 space-y-8">
        {createMetricSections(data).map((section, index) => (
          <MetricSection
            key={index}
            title={section.title}
            color={section.color}
            metrics={section.metrics}
          />
        ))}
      </div>
    </div>
  );
}
